import { useEffect } from "react";
import { ROOMS } from "@/lib/yuoDesign";
import StoneOrb from "@/components/yuo/StoneOrb";
import { MFONT } from "./MobileHeader";

// Bottom sheet for the ⋯ button. rows: [{ label, hint, color: roomKey, right: "›"|"✓"|"☾"|"+", onClick, testId }]
export default function MoreSheet({ open, title, rows = [], onClose, children, testId = "m-sheet" }) {
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div data-testid={testId} className="m-appear" onClick={onClose} style={{
      position: "absolute", inset: 0, zIndex: 20, display: "flex", alignItems: "flex-end", fontFamily: MFONT,
      background: "var(--m-backdrop)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)",
    }}>
      <div className="m-sheet-panel m-scroll" onClick={(e) => e.stopPropagation()} style={{
        width: "100%", maxHeight: "84%", overflowY: "auto", borderRadius: "32px 32px 0 0",
        padding: "10px 12px calc(30px + env(safe-area-inset-bottom, 0px))", background: "var(--m-sheet-bg)",
        display: "flex", flexDirection: "column", gap: 6,
      }}>
        <div style={{ width: 40, height: 4, borderRadius: 999, background: "var(--m-grabber)", margin: "0 auto 8px", flex: "none" }} />
        {title && <div style={{ fontSize: 9, letterSpacing: "0.3em", textTransform: "uppercase", color: "var(--m-row-hint)", padding: "4px 14px 8px" }}>{title}</div>}
        {rows.map((r, i) => (
          <SheetRow key={r.testId || i} {...r} onClick={() => { r.onClick?.(); onClose?.(); }} />
        ))}
        {children}
      </div>
    </div>
  );
}

export function SheetRow({ label, hint, color = "mirror", right = "›", onClick, testId, disabled }) {
  const meta = ROOMS[color] || ROOMS.mirror;
  return (
    <button type="button" data-testid={testId} onClick={onClick} disabled={disabled} className="m-row" style={{
      minHeight: 46, width: "100%", borderRadius: 16, border: "none", cursor: disabled ? "default" : "pointer",
      display: "flex", alignItems: "center", gap: 12, padding: "8px 14px", textAlign: "left",
      background: "var(--m-row-bg)", color: "var(--yuo-ink)", fontFamily: MFONT, boxShadow: "none",
      opacity: disabled ? 0.45 : 1, flex: "none",
    }}>
      <StoneOrb color={color} size={14} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{label}</div>
        {hint && <div style={{ fontSize: 10, color: "var(--m-row-hint)", marginTop: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{hint}</div>}
      </div>
      <span style={{ fontSize: 13, color: right === "✓" ? meta.text : "var(--m-row-hint)", flex: "none" }}>{right}</span>
    </button>
  );
}
